interface IconItem {
  name: string;
  icon: string;
}

export const aiIcons: IconItem[] = [
  { name: 'OpenAI', icon: '/technologies/openai.svg' },
  { name: 'Claude', icon: '/technologies/claude.svg' },
  { name: 'Groq', icon: '/technologies/groq.svg' },
  { name: 'LangChain', icon: '/technologies/langchain.svg' },
  { name: 'CrewAI', icon: '/technologies/crewai.svg' },
  { name: 'Streamlit', icon: '/technologies/streamlit.svg' },
  { name: 'LLM', icon: '/technologies/llm.svg' },
  { name: 'ChromaDB', icon: '/technologies/chromadb.svg' },
  // { name: 'Pandas', icon: '/technologies/pandas.svg' },
  { name: 'NumPy', icon: '/technologies/numpy.svg' },
];

export const devopsIcons: IconItem[] = [
  { name: 'Docker', icon: '/technologies/docker.svg' },
  { name: 'Kubernetes', icon: '/technologies/kubernetes.svg' },
  { name: 'AWS', icon: '/technologies/aws.svg' },
  { name: 'GCP', icon: '/technologies/gcp.svg' },
  { name: 'Azure', icon: '/technologies/azure.svg' },
  // { name: 'CI/CD', icon: '/technologies/ci-cd.svg' },
  { name: 'Git', icon: '/technologies/git.svg' },
  // { name: 'GitHub', icon: '/technologies/github.svg' },
  // { name: 'GitLab', icon: '/technologies/gitlab.svg' },
  // { name: 'Linux', icon: '/technologies/linux.svg' },
  // { name: 'Bash', icon: '/technologies/bash.svg' },
  { name: 'OpenStack', icon: '/technologies/openstack.svg' },
];

export const frontendIcons: IconItem[] = [
  { name: 'React', icon: '/technologies/reactjs.svg' },
  { name: 'Next.js', icon: '/technologies/nextjs.svg' },
  { name: 'Vue.js', icon: '/technologies/vuejs.svg' },
  { name: 'TypeScript', icon: '/technologies/typescript.svg' },
  { name: 'JavaScript', icon: '/technologies/javascript.svg' },
  { name: 'HTML', icon: '/technologies/html.svg' },
  { name: 'CSS', icon: '/technologies/css.svg' },
  { name: 'Tailwind CSS', icon: '/technologies/tailwindcss.svg' },
  { name: 'Bootstrap', icon: '/technologies/bootstrap.svg' },
  { name: 'jQuery', icon: '/technologies/jquery.svg' },
  { name: 'QRCode.js', icon: '/technologies/qrcodejs.svg' },
];

export const backendIcons: IconItem[] = [
  { name: 'Python', icon: '/technologies/python.svg' },
  { name: 'Django', icon: '/technologies/django.svg' },
  { name: 'DRF', icon: '/technologies/drf.svg' },
  { name: 'FastAPI', icon: '/technologies/fastapi.svg' },
  { name: 'Flask', icon: '/technologies/flask.svg' },
  { name: 'Elixir', icon: '/technologies/elixir.svg' },
  { name: 'Phoenix', icon: '/technologies/phoenix.svg' },
  { name: 'Ruby', icon: '/technologies/ruby.svg' },
  { name: 'Rails', icon: '/technologies/rails.svg' },
  { name: 'NestJS', icon: '/technologies/nestjs.svg' },
  { name: 'Celery', icon: '/technologies/celery.svg' },
];

export const databaseIcons: IconItem[] = [
  { name: 'PostgreSQL', icon: '/technologies/postgresql.svg' },
  { name: 'MongoDB', icon: '/technologies/mongodb.svg' },
  { name: 'Redis', icon: '/technologies/redis.svg' },
  { name: 'MySQL', icon: '/technologies/mysql.svg' },
  { name: 'SQLite', icon: '/technologies/sqlite.svg' },
  { name: 'Snowflake', icon: '/technologies/snowflake.svg' },
];

export const testingIcons: IconItem[] = [
  { name: 'Pytest', icon: '/technologies/pytest.svg' },
  { name: 'Unit Test', icon: '/technologies/unit-test.svg' },
  { name: 'Cypress', icon: '/technologies/cypress.svg' },
  { name: 'JMeter', icon: '/technologies/jmeter.svg' },
  { name: 'Locust', icon: '/technologies/locust.svg' },
  { name: 'Selenium', icon: '/technologies/selenium.svg' },
  { name: 'Playwright', icon: '/technologies/playwright.svg' },
];

export const integrationIcons: IconItem[] = [
  { name: 'Twilio', icon: '/technologies/twilio.svg' },
  { name: 'Twitter', icon: '/technologies/twitter.svg' },
  { name: 'PayPal', icon: '/technologies/paypal.svg' },
  { name: 'SendGrid', icon: '/technologies/sendgrid.svg' },
  { name: 'Slack', icon: '/technologies/slack.svg' },
  { name: 'Stripe', icon: '/technologies/stripe.svg' },
  { name: 'Mailchimp', icon: '/technologies/mailchimp.svg' },
  { name: 'OAuth', icon: '/technologies/oauth.svg' },
  { name: 'HubSpot', icon: '/technologies/hubspot.svg' },
  { name: 'Google Drive', icon: '/technologies/google-drive.svg' },
  { name: 'Google Maps', icon: '/technologies/google-maps.svg' },
  { name: 'Binance', icon: '/technologies/binance.svg' },
  { name: 'Composio', icon: '/technologies/composio.svg' },
];

export const ideIcons: IconItem[] = [
  { name: 'VS Code', icon: '/technologies/vscode.svg' },
  { name: 'PyCharm', icon: '/technologies/pycharm.svg' },
];

export const scrapingIcons: IconItem[] = [
  { name: 'Scrapy', icon: '/technologies/scrapy.svg' },
];

export const packageIcons: IconItem[] = [
  { name: 'PyPI', icon: '/technologies/pypi.svg' },
  { name: 'Boto', icon: '/technologies/boto.svg' },
];

export const fullstackIcons: IconItem[] = [
  { name: 'React', icon: '/technologies/reactjs.svg' },
  { name: 'Next.js', icon: '/technologies/nextjs.svg' },
  { name: 'Vue.js', icon: '/technologies/vuejs.svg' },
  { name: 'TypeScript', icon: '/technologies/typescript.svg' },
  { name: 'JavaScript', icon: '/technologies/javascript.svg' },
  { name: 'Python', icon: '/technologies/python.svg' },
  { name: 'Django', icon: '/technologies/django.svg' },
  { name: 'FastAPI', icon: '/technologies/fastapi.svg' },
  // { name: 'Flask', icon: '/technologies/flask.svg' },
  { name: 'Elixir', icon: '/technologies/elixir.svg' },
  { name: 'Phoenix', icon: '/technologies/phoenix.svg' },
  { name: 'Tailwind CSS', icon: '/technologies/tailwindcss.svg' },
  { name: 'Bootstrap', icon: '/technologies/bootstrap.svg' },
  { name: 'PostgreSQL', icon: '/technologies/postgresql.svg' },
  { name: 'MongoDB', icon: '/technologies/mongodb.svg' },
  { name: 'Redis', icon: '/technologies/redis.svg' },
]; 